// export const environment = {
//   production: true,
//   apiUrl: 'https://bnlwe-es01-p-57278-unilevercom-webapp-02.azurewebsites.net',
//   clientId: '220e11e0-3d11-4980-921e-16b5e4ace5c7',
//   tenantId: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
//   authority:
//     'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
//   redirectUri:
//     'https://claims-sparci.unilever.com/',
// };
export const environment = {
  production: false,
  apiUrl: 'https://claims-sparci.unilever.com',
  socketUrl:
    'https://bnlwe-es02-p-931432-unilevercom-webapp-01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '9cadbd36-4b37-43a9-86d6-3c99442c251d',
      authority:
        'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
      // redirectUri: 'http://localhost:4200',
      redirectUri: 'https://claims-sparci.unilever.com/',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/.default',
  },
  // apiUrl: 'https://sparci-dev.unilever.com',

  // clientId: '955fde3e-e37e-42a7-98b3-64882b3e2aca',
  // tenantId: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  // authority:
  //   'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
  // // redirectUri: 'http://localhost:4300/',
  // redirectUri: 'https://sparci-dev.unilever.com/.auth/login/aad/callback',
};